import {ProductStatus} from 'core/dictionaries';

import {RemarkingReason} from './products-detail';

export const REMARKING_AUDIT_EVENTS = [
    'REMARKING_DOCUMENT_CREATED',
    'REMARKING_DOCUMENT_SUBMITTED',
    'REMARKING_DOCUMENT_PROCESSING',
    'REMARKING_DOCUMENT_COMPLETED',
    'REMARKING_DOCUMENT_REJECTED',
] as const;

export const REMARKING_AUDIT_REASONS: RemarkingReason[] = ['DAMAGED', 'LOST', 'MISPRINT', 'OTHER'];
export const REMARKING_AUDIT_SOURCES = ['USER_FORM', 'API_INTEGRATION'] as const;
export type RemarkingAuditEventType = typeof REMARKING_AUDIT_EVENTS[number];

export interface RemarkingAuditEntry {
    eventId: string;
    eventType: RemarkingAuditEventType;
    eventTimestamp: string;
    userId?: string;
    userFullName?: string;
    userRole?: string;
    clientId?: number;
    organizationId?: number;
    organizationName?: string;
    organizationTin?: string;
    ipAddress?: string;
    userAgent?: string;
    productCode?: string;
    documentId?: string;
    sourceFormation?: typeof REMARKING_AUDIT_SOURCES[number];
    oldMarkingCode?: string;
    newMarkingCode?: string;
    remarkingReason?: RemarkingReason;
    comment?: string;
    oldCodeStatusAtSubmission?: ProductStatus;
    oldCodeStatusBeforeRemarking?: ProductStatus;
    oldCodeStatusAfterRemarking?: ProductStatus;
    oldCodeDisposalReason?: string;
    newCodeStatus?: ProductStatus;
    replacedByMarkingCodeId?: string;
    replacesMarkingCodeId?: string;
    errorCode?: string;
    rejectionReason?: string;
}

export interface RemarkingAuditParams {
    userRole?: string;
    userFullName?: string;
    organizationName?: string;
    organizationTin?: string;
    eventType?: string;
    from?: string;
    to?: string;
    documentId?: string;
    productCode?: string;
    oldMarkingCode?: string;
    newMarkingCode?: string;
    remarkingReason?: string;
    sourceFormation?: string;
    page?: number;
    size?: number;
}

export interface RemarkingAuditPage {
    data: RemarkingAuditEntry[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
}
